var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-message d-flex justify-content-start align-items-start flex-column p-3",class:_vm.scaniaMessage.type},[_vm._v(" "+_vm._s(_vm.scaniaMessage.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }